import apiClient from "./api";
const ESTUDIOS_API_BASE_URL = "/estudios";

class EstudiosService {
  getEstudios() {
    return apiClient.get(ESTUDIOS_API_BASE_URL);
  }

  deleteEstudio(idEstudio) {
    return apiClient.delete(`${ESTUDIOS_API_BASE_URL}/${idEstudio}`);
  }
  updateEstudio(estudio, estudioId) {
    return apiClient.put(ESTUDIOS_API_BASE_URL + "/" + estudioId, estudio);
  }
  agregarEstudio(estudio) {
    return apiClient.post(ESTUDIOS_API_BASE_URL, estudio);
  }

  async getEstudioPorId(estudioId) {
    try {
      const response = await apiClient.get(`${ESTUDIOS_API_BASE_URL}/${estudioId}`,);
      return response.data.estudio[0];
    } catch (error) {
      console.error(error);
    }
  }

  async buscarEstudios(busqueda) {
    try {
      const response = await apiClient.post(`${ESTUDIOS_API_BASE_URL}/buscar`, { busqueda });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

}


export default new EstudiosService();
